import React from 'react';

import { HeaderStyles, LineIcon, cn } from 'scbk-ui-web';

import { useTranslation } from 'react-i18next';

interface SubMainHeaderProps {
  title?: string | React.ReactNode | undefined;
  isNew?: boolean;
  isScrolled?: boolean;
  onHandleAlert?: () => void;
  onHandleSearchPanel?: () => void;
  openUserInfoPopup?: () => void;
}

const SubMainHeader = ({
  title,
  isNew = false,
  onHandleAlert,
  onHandleSearchPanel,
  openUserInfoPopup,
}: SubMainHeaderProps) => {
  // 다국어처리
  const { t } = useTranslation();

  return (
    <div className={HeaderStyles['main-header-wrap']}>
      <header className={HeaderStyles['header']}>
        <h1
          className="heading-h4 text-base-white font-weight-bold"
          onClick={(e) => {
            e.preventDefault();
            openUserInfoPopup?.();
          }}
        >
          {title}
        </h1>
        {/* <div className={HeaderStyles['header-inner']}> */}
        <div className={cn(HeaderStyles['header-inner-bg'], 'com-box-shadow')}>
          <div className="relative h-6">
            <button
              aria-label={t('Layout.SubMainHeader.001', {
                defaultValue: '알림',
              })}
              onClick={(e) => {
                e.preventDefault();
                onHandleAlert && onHandleAlert();
              }}
              data-cn="홈 Header"
              data-ac="알림 확인"
              data-tx="알림 아이콘"
            >
              <LineIcon icoColor="bg-icon-basic-06" icoName="ico-alert" />
            </button>
            {isNew && (
              <span aria-label="" className={HeaderStyles['icon-new']}>
                <i aria-hidden="true" className="sr-only">
                  new
                </i>
              </span>
            )}
          </div>
          <button
            aria-label={t('Layout.SubMainHeader.002', {
              defaultValue: '검색',
            })}
            onClick={onHandleSearchPanel}
            data-cn="홈 Header"
            data-ac="검색 하기"
            data-tx="검색 아이콘"
          >
            <LineIcon icoColor="bg-icon-basic-06" icoName="ico-search" />
          </button>
        </div>
        {/* </div> */}
      </header>
    </div>
  );
};

export { SubMainHeader };
